export const createOffer = {
  // ── Page / Breadcrumb ──────────────────────────────────────────────────────
  CO_PAGE_TITLE:              'Skapa kunderbjudande',
  CO_OFFER_NO_LABEL:          'Erbjudandenummer',
  CO_HEADER_EYEBROW:          'Nytt dokument',
  CO_PAGE_SUBTITLE:           'På den här sidan kan du skapa ett kunderbjudande genom att lägga till kunden, den erbjudna tjänsten, ersättning samt en granskning och signatur – allt på ett ställe.',

  // ── Stepper ────────────────────────────────────────────────────────────────
  CO_STEP_COMPANY_LOGO:              'Företagslogotyp',
  CO_STEP_PARTIES_INFO:              'Kund- & erbjudandeuppgifter',
  CO_STEP_ASSIGNMENT_COMPENSATION:   'Uppdrag & ersättning',
  CO_STEP_LEGAL_SIGNATURES:          'Villkor & signaturer',
  CO_STEP_COMPANY_LOGO_SUB:            'Anpassa dokumentet',
  CO_STEP_PARTIES_INFO_SUB:            'Vem gäller det',
  CO_STEP_ASSIGNMENT_COMPENSATION_SUB: 'Omfattning & betalning',
  CO_STEP_LEGAL_SIGNATURES_SUB:        'Granska & signera',

  // ── Step 0 — Företagslogotyp ─────────────────────────────────────────────────
  CO_LOGO_CARD_TITLE:         'Företagslogotyp',
  CO_LOGO_CARD_SUBTITLE:      'Ladda upp din företagslogotyp för att anpassa kunderbjudandedokumentet.',
  CO_LOGO_NO_LOGO:            'Ingen företagslogotyp uppladdad',
  CO_LOGO_CHANGE_IN_SETTINGS: 'Byt logotyp i profilinställningar',
  CO_LOGO_SETTINGS_NOTE:      'Din företagslogotyp konfigureras i dina profilinställningar och visas på alla dokument.',
  CO_INVOZIO_INFO_TITLE:      'Invozio-information',
  CO_INVOZIO_INFO_COMPANY:    'Invozio LV SIA',
  CO_INVOZIO_INFO_REG:        '502085-4062',
  CO_INVOZIO_INFO_REF:        '(nedan kallat "Invozio")',
  CO_PREFERRED_LANGUAGE_LABEL:   'Föredraget språk',
  CO_PREFERRED_LANGUAGE_HINT:    'Språket det här erbjudandet (och dess dokument/e-post) skapas på. Är förvalt till ditt plattformsspråk första gången, och kommer sedan ihåg ditt senaste val.',

  // ── Step 1 — Kund- & erbjudandeuppgifter ────────────────────────────────────
  CO_CUSTOMER_CARD_TITLE:        'Kundinformation',
  CO_CUSTOMER_ADD_CUSTOMER:      'Lägg till ny kund',
  CO_CUSTOMER_SELECT_LABEL:      'Välj befintlig kund:',
  CO_CUSTOMER_SELECT_PLACEHOLDER: 'Välj kund',
  CO_CUSTOMER_REMOVE_CUSTOMER:   'Ta bort',
  CO_CUSTOMER_NO_CUSTOMERS:      'Kunden hittades inte',
  CO_CONTACT_PERSON_LABEL:       'Kontaktperson',
  CO_CONTACT_PERSON_HINT:        'Ange kontaktpersonens namn',
  CO_CONTACT_PHONE_LABEL:        'Kontakttelefon',
  CO_CONTACT_PHONE_HINT:         'Ange ett telefonnummer',
  CO_OFFERED_SERVICES_LABEL:     'Erbjuden tjänst (namn)',
  CO_OFFERED_SERVICES_HINT:      't.ex. Konsulttjänster',
  CO_WORK_DESC_LABEL:            'Tjänstebeskrivning',
  CO_WORK_DESC_HINT:             'Beskriv vad erbjudandet omfattar',

  // ── Step 2 — Uppdrag & ersättning ────────────────────────────────────────────
  CO_ASSIGN_PERIOD_TITLE:        'Erbjudandeperiod',
  CO_ASSIGN_PERIOD_LABEL:        'Uppdragsperiod',
  CO_ASSIGN_PERIOD_HINT:         't.ex. Löpande',
  CO_ASSIGN_START_DATE:          'Startdatum',
  CO_ASSIGN_END_DATE:            'Slutdatum',
  CO_DATE_PLACEHOLDER:           'åååå/mm/dd',
  CO_ASSIGN_NO_END_DATE:         'Inget slutdatum',
  CO_ASSIGN_NO_END_DATE_INFO:    'Markera om uppdraget löper tills vidare utan ett bestämt slutdatum.',
  CO_ASSIGN_NOTICE_CHECKBOX:     'Uppsägningstid',
  CO_ASSIGN_NOTICE_INFO:         'Markera om endera parten måste meddela i förväg innan uppdraget avslutas i förtid.',
  CO_ASSIGN_NOTICE_LABEL:        'Uppsägningstid',
  CO_ASSIGN_NOTICE_1M:           '1 månad',
  CO_ASSIGN_NOTICE_2M:           '2 månader',
  CO_ASSIGN_NOTICE_3M:           '3 månader',
  CO_ASSIGN_NOTICE_6M:           '6 månader',
  CO_ASSIGN_NOTICE_HINT:         'Kunden måste meddelas så här lång tid innan erbjudandets slutdatum.',
  CO_ASSIGN_DESC_TITLE:          'Uppdragsbeskrivning',
  CO_ASSIGN_DESC_LABEL:          'Beskriv de tjänster och leveranser som ska tillhandahållas inom ramen för detta erbjudande.',
  CO_ASSIGN_DESC_HINT:           'Ange en detaljerad beskrivning av uppdraget...',
  CO_SPECIAL_TERMS_LABEL:        'Särskilda villkor:',
  CO_SPECIAL_TERMS_HINT:         'Ange eventuella särskilda villkor...',
  CO_COMP_TITLE:                 'Ersättningsdetaljer',
  CO_COMP_TYPE_LABEL:            'Ersättningstyp',
  CO_COMP_TYPE_PLACEHOLDER:      'Välj typ',
  CO_COMP_TYPE_PER_HOUR:         'Betalning per timme',
  CO_COMP_TYPE_PER_DAY:          'Betalning per dag',
  CO_COMP_TYPE_PER_WEEK:         'Betalning per vecka',
  CO_COMP_TYPE_PER_MONTH:        'Betalning per månad',
  CO_COMP_TYPE_AS_AGREED:        'Fast pris',
  CO_COMP_TYPE_PER_UNIT:         'Betalning per enhet',
  CO_COMP_UNIT_LABEL:            'Antal enheter',
  CO_COMP_UNIT_HINT:             't.ex. 10',
  CO_COMP_CURRENCY_LABEL:        'Valuta',
  CO_COMP_AMOUNT_LABEL:          'Belopp',
  CO_COMP_AMOUNT_HINT:           'Ange belopp',
  CO_COMP_INVOICE_NOTE:          'Fakturering för utfört arbete sker månadsvis. Betalningsvillkor är 30 dagar. Påminnelseavgift om 60 SEK och inkassoavgift om 180 SEK tillämpas, eller de belopp som annars föreskrivs av lag. Dröjsmålsränta tillkommer.',

  // ── Step 3 — Villkor & signaturer ────────────────────────────────────────────
  CO_LEGAL_CARD_TITLE:               'Villkor & bestämmelser',
  CO_LEGAL_TAXES_HEADING:            'Skatter och avgifter',
  CO_LEGAL_TAXES_BODY:               'Ersättningen är exklusive moms. Invozio ansvarar ensamt för löneadministration, skatteavdrag, sociala avgifter och andra lagstadgade skyldigheter kopplade till tjänsteleverantören. Vid rimlig begäran ska Invozio kunna visa bevis på efterlevnad.',
  CO_LEGAL_INSURANCE_HEADING:        'Försäkring',
  CO_LEGAL_INSURANCE_BODY:           'Invozio upprätthåller försäkringsskydd i enlighet med sina vid var tid gällande försäkringsvillkor. Skyddet omfattas av villkoren, undantagen och begränsningarna i respektive försäkring.',
  CO_LEGAL_CONFIDENTIALITY_HEADING:  'Sekretess',
  CO_LEGAL_CONFIDENTIALITY_BODY:     'Egenanställde och Invozio åtar sig att inte lämna ut konfidentiell information som erhållits genom uppdraget, förutom när det krävs enligt lag eller för administration av uppdraget.',
  CO_LEGAL_ROLE_HEADING:             'Tjänsteleverantörens ansvar',
  CO_LEGAL_ROLE_BODY:                'Tjänsterna utförs av en oberoende tjänsteleverantör som anlitas genom Invozio. Tjänsteleverantören ansvarar ensamt för utförande, kvalitet, kvalifikationer och leverans av tjänsterna. Invozios roll är begränsad till administrativa tjänster, fakturering, löneadministration, försäkring och regelefterlevnad.',
  CO_LEGAL_LIMITATION_HEADING:       'Ansvarsbegränsning',
  CO_LEGAL_LIMITATION_BODY:          'Invozios sammanlagda ansvar enligt detta avtal ska inte överstiga de avgifter som kunden betalat till Invozio under de tolv (12) månader som föregår kravet.',
  CO_LEGAL_ACK_HEADING:              'Kundens bekräftelse',
  CO_LEGAL_ACK_BODY:                 'Kunden bekräftar att samtliga tjänster tillhandahålls direkt av frilansaren, som bär det fulla och exklusiva ansvaret för omfattning, kvalitet, utförande och leverans av dessa tjänster.',
  CO_REVIEW_CONFIRM_TEXT:        'Jag bekräftar att all information som lämnats för detta erbjudande är korrekt och fullständig enligt min bästa vetskap. Jag förstår att denna information kommer att användas för att upprätta det slutliga erbjudandedokumentet och att jag är personligen ansvarig för den inlämnade informationen samt eventuella konsekvenser av felaktigheter.',
  CO_SIG_CARD_TITLE:             'Signaturer',
  CO_SIG_FREELANCER_LABEL:       'På uppdrag av frilansaren:',
  CO_SIG_DATE_LABEL:             'Datum',
  CO_SIG_SIGNATURE_LABEL:        'Underskrift',
  CO_SIG_DRAW_BTN:               'Rita underskrift',
  CO_SIG_UPLOAD_BTN:             'Ladda upp underskrift',
  CO_SIG_CANVAS_HINT_DRAW:       'Rita din underskrift här',
  CO_SIG_CANVAS_HINT_UPLOAD:     'Din uppladdade underskrift visas här',
  CO_SIG_CLEAR_BTN:              'Rensa',
  CO_SIG_NAME_LABEL:             'Namnförtydligande',
  CO_SIG_NAME_HINT:              'Ange ditt fullständiga namn',
  CO_SIG_PLACE_LABEL:            'Ort',
  CO_SIG_INVOZIO_LABEL:          'På uppdrag av Invozio LV SIA:',
  CO_SIG_INVOZIO_PRE_SIGNED:     'Digitalt förtecknat',
  CO_SIG_CUSTOMER_LABEL:         'På uppdrag av kunden:',
  CO_SIG_CUSTOMER_PENDING_BADGE: 'Väntar på svar',
  CO_SIG_CUSTOMER_SIGNED_BADGE:  'Signerad',
  CO_SIG_CUSTOMER_PENDING_BODY:  'Kunden accepterar eller avböjer efter att du har skickat erbjudandet.',
  CO_SIG_CUSTOMER_PLACEHOLDER_NAME: 'Kund',

  // ── Footer actions ─────────────────────────────────────────────────────────
  CO_BTN_CANCEL:      'Avbryt',
  CO_BTN_BACK:        'Tillbaka',
  CO_BTN_NEXT:        'Nästa',
  CO_BTN_SAVE_DRAFT:  'Spara som utkast',
  CO_BTN_SAVING_DRAFT: 'Sparar…',
  CO_BTN_SEND_OFFER:  'Granska och skicka',
  CO_BTN_SENDING:     'Skickar…',

  // ── Validation messages ────────────────────────────────────────────────────
  CO_VAL_FIELD_REQUIRED:      'Detta fält är obligatoriskt.',
  CO_VAL_CUSTOMER_REQUIRED:   'Välj en kund.',
  CO_VAL_END_DATE_REQUIRED:   "Ange ett slutdatum eller markera 'Inget slutdatum'.",
  CO_VAL_END_AFTER_START:     'Slutdatumet måste vara efter startdatumet.',
  CO_VAL_AMOUNT_POSITIVE:     'Ange ett giltigt belopp större än 0.',
  CO_VAL_TERMS_REQUIRED:      'Bekräfta för att fortsätta.',
  CO_VAL_SIGNATURE_REQUIRED:  'Lägg till en underskrift.',

  // ── Toast messages ─────────────────────────────────────────────────────────
  CO_TOAST_CUSTOMER_REQUIRED: 'Välj en kund innan du skickar in.',
  CO_TOAST_FILL_REQUIRED:     'Fyll i de obligatoriska fälten',
  CO_TOAST_SUCCESS:           'Erbjudandet skapades framgångsrikt!',
  CO_TOAST_ERROR:             'Det gick inte att skapa erbjudandet. Försök igen.',
  CO_TOAST_UPDATE_SUCCESS:    'Erbjudandet uppdaterades framgångsrikt!',
  CO_TOAST_UPDATE_ERROR:      'Det gick inte att uppdatera erbjudandet. Försök igen.',
  CO_TOAST_LOAD_ERROR:        'Det gick inte att ladda erbjudandet. Försök igen.',
  CO_TOAST_SEND_SUCCESS:      'Erbjudandet sparades och skickades till kunden!',
  CO_TOAST_SEND_ERROR:        'Det gick inte att skicka erbjudandet till kunden. Försök igen.',
  CO_TOAST_SEND_LOOKUP_ERROR: 'Erbjudandet sparades, men kunde inte skickas automatiskt. Skicka det istället från erbjudandelistan.',

  // ── Send-offer preview modal ───────────────────────────────────────────────
  CO_PREVIEW_MODAL_TITLE:    'Granska innan du skickar',
  CO_PREVIEW_MODAL_SUBTITLE: 'Förhandsgranska erbjudandet precis som din kund kommer att få det.',
  CO_PREVIEW_SEND_TO:        'Det här erbjudandet skickas till {{name}} ({{email}}).',
  CO_PREVIEW_SWIPE_UP:       'Svep upp',
  CO_PREVIEW_SWIPE_DOWN:     'Svep ner',
  CO_PREVIEW_DOWNLOAD:       'Ladda ner PDF',
  CO_BTN_CONFIRM_SEND:       'Skicka till kund',

  // ── Edit mode ──────────────────────────────────────────────────────────────
  CO_PAGE_TITLE_EDIT: 'Redigera kunderbjudande',
  CO_BTN_UPDATE:      'Uppdatera',
  CO_BTN_UPDATING:    'Uppdaterar…',
  CO_LOADING_OFFER:   'Laddar erbjudande…',

  // ── Offers grid ──────────────────────────────────────────────────────────────
  COG_TITLE:             'Dina erbjudanden',
  COG_LOADING:           'Laddar erbjudanden…',
  COG_ERROR:             'Det gick inte att ladda erbjudanden. Uppdatera sidan.',
  COG_EMPTY:             'Inga erbjudanden ännu.',
  COG_EMPTY_ARCHIVED:    'Inga arkiverade erbjudanden.',
  COG_CREATE_FIRST:      'Skapa ditt första erbjudande',
  COG_BTN_NEW:            'Nytt erbjudande',
  COG_TAB_ALL:           'Alla',
  COG_TAB_ARCHIVED:      'Arkiverade',
  COG_COL_OFFER_NO:      'Erbjudandenr.',
  COG_COL_CUSTOMER:      'Kund',
  COG_COL_SERVICE:       'Erbjuden tjänst',
  COG_COL_START_DATE:    'Startdatum',
  COG_COL_END_DATE:      'Slutdatum',
  COG_COL_AMOUNT:        'Belopp',
  COG_COL_STATUS:        'Status',
  COG_COL_CREATED:       'Skapad',
  COG_COL_ACTIONS:       'Åtgärder',
  COG_NO_END_DATE:       'Inget slutdatum',
  COG_STATUS_DRAFT:             'Utkast',
  COG_STATUS_PENDING_SIGNATURE: 'Skickat',
  COG_STATUS_ACCEPTED:          'Signerat',
  COG_STATUS_EXPIRED:           'Utgånget',
  COG_STATUS_DECLINED:          'Avböjt',
  COG_STATUS_CANCELLED:         'Avbrutet',
  COG_STATUS_ARCHIVED:          'Arkiverat',
  COG_ACTION_DOWNLOAD_PDF: 'Ladda ned PDF',
  COG_ACTION_EDIT:         'Redigera erbjudande',
  COG_ACTION_EDIT_DISABLED: 'Endast erbjudanden med status Utkast kan redigeras',
  COG_ACTION_EDIT_DISABLED_ARCHIVED: 'Arkiverade erbjudanden kan inte redigeras',
  COG_DOWNLOAD_SUCCESS:    'PDF nedladdad.',
  COG_DOWNLOAD_ERROR:      'Det gick inte att ladda ned PDF. Försök igen.',
  COG_ACTION_SEND:                    'Skicka till kund',
  COG_ACTION_SEND_DISABLED_ARCHIVED:  'Arkiverade erbjudanden kan inte skickas',
  COG_ACTION_SEND_DISABLED_EXPIRED:   'Utgångna erbjudanden kan inte skickas. Duplicera det för att skapa en ny version.',
  COG_ACTION_SEND_DISABLED_ACCEPTED:  'Det här erbjudandet är redan signerat och kan inte skickas igen.',
  COG_ACTION_SEND_DISABLED_DECLINED:  'Det här erbjudandet avböjdes och kan inte skickas igen. Duplicera det för att skapa en ny version.',
  COG_ACTION_SEND_DISABLED_CANCELLED: 'Avbrutna erbjudanden kan inte skickas.',
  COG_ACTION_DUPLICATE:   'Duplicera / Skapa ny version',
  COG_SEND_NO_EMAIL:      'Den här kunden har ingen registrerad e-postadress.',
  COG_SEND_SUCCESS:       'Erbjudandet har skickats via e-post.',
  COG_SEND_ERROR:         'Det gick inte att skicka erbjudandet. Försök igen.',
  COG_ACTION_ARCHIVE:      'Arkivera erbjudande',
  COG_ACTION_UNARCHIVE:    'Återställ erbjudande',
  COG_ARCHIVE_SUCCESS:     'Erbjudandet har arkiverats.',
  COG_ARCHIVE_ERROR:       'Det gick inte att arkivera erbjudandet. Försök igen.',
  COG_UNARCHIVE_SUCCESS:   'Erbjudandet har återställts.',
  COG_UNARCHIVE_ERROR:     'Det gick inte att återställa erbjudandet. Försök igen.',

  // ── Public customer offer accept/decline page ──────────────────────────────
  COSIGN_PAGE_TITLE:           'Kunderbjudande',
  COSIGN_PAGE_SUBTITLE:        'Granska erbjudandet nedan innan du accepterar eller avböjer det.',
  COSIGN_LOADING:              'Laddar erbjudande…',
  COSIGN_LOAD_ERROR_TITLE:     'Länken är inte längre giltig',
  COSIGN_LOAD_ERROR_BODY:      'Vi kunde inte ladda det här erbjudandet. Länken kan ha upphört att gälla, redan använts eller vara ogiltig.',
  COSIGN_PDF_CARD_TITLE:       'Erbjudandedokument',
  COSIGN_BTN_ACCEPT:           'Acceptera erbjudande',
  COSIGN_BTN_DECLINE:          'Avböj',
  COSIGN_SIGN_CARD_TITLE:      'Bekräfta & signera',
  COSIGN_SIGNATURE_LABEL:      'Underskrift',
  COSIGN_CANVAS_HINT:          'Rita din underskrift här',
  COSIGN_CLEAR_BTN:            'Rensa',
  COSIGN_NAME_LABEL:           'Namnförtydligande',
  COSIGN_NAME_HINT:            'Ange ditt fullständiga namn',
  COSIGN_TERMS_CONFIRM_TEXT:   'Jag har granskat erbjudandet ovan och accepterar dess villkor.',
  COSIGN_BTN_CONFIRM_SIGN:     'Bekräfta & signera',
  COSIGN_BTN_SIGNING:          'Signerar…',
  COSIGN_BTN_CANCEL:           'Avbryt',
  COSIGN_DECLINE_CARD_TITLE:   'Avböj erbjudande',
  COSIGN_DECLINE_REASON_LABEL: 'Berätta gärna varför du avböjer det här erbjudandet:',
  COSIGN_DECLINE_REASON_HINT:  'Ange din anledning...',
  COSIGN_BTN_CONFIRM_DECLINE:  'Bekräfta avböjning',
  COSIGN_BTN_DECLINING:        'Avböjer…',
  COSIGN_VAL_SIGNATURE_REQUIRED: 'Lägg till en underskrift.',
  COSIGN_VAL_NAME_REQUIRED:      'Ange ditt fullständiga namn.',
  COSIGN_VAL_TERMS_REQUIRED:     'Bekräfta att du accepterar erbjudandet.',
  COSIGN_VAL_REASON_REQUIRED:    'Ange en anledning.',
  COSIGN_SIGN_SUCCESS_TITLE:   'Erbjudandet accepterat',
  COSIGN_SIGN_SUCCESS_BODY:    'Tack — erbjudandet har accepterats och signerats. Du kan nu stänga det här fönstret.',
  COSIGN_SIGN_ERROR:           'Det gick inte att skicka din underskrift. Försök igen.',
  COSIGN_BTN_DOWNLOAD:         'Ladda ned signerat erbjudande',
  COSIGN_BTN_DOWNLOADING:      'Laddar ned…',
  COSIGN_DOWNLOAD_ERROR:       'Det gick inte att ladda ned det signerade erbjudandet. Försök igen.',
  COSIGN_DECLINE_SUCCESS_TITLE: 'Erbjudandet avböjt',
  COSIGN_DECLINE_SUCCESS_BODY:  'Du har avböjt det här erbjudandet. Avsändaren har meddelats.',
  COSIGN_DECLINE_ERROR:         'Det gick inte att skicka din avböjning. Försök igen.',
};
